<template>
  <SplitModal
    :can-close="settings.canClose"
    :active="modalOpen"
    scope="auth"
    @close="handleCancel"
  >
    <template slot="left">
      <AuthForms
        class="max-w-lg m-auto"
        register-description="Sign up to get your logo"
        login-description="Log in to get your logo"
        :starting-page="settings.modalType"
        :register-title="registerTitle"
        :login-title="loginTitle"
        @authenticated="handleFormSubmit"
      />
    </template>

    <template slot="right">
      <div
        class="absolute inset-0 bg-cover"
        style="background-image: url('/img/editor-preview-in-browser.png')"
      ></div>
    </template>
  </SplitModal>
</template>

<script>
import SplitModal from '@/components/modals/SplitModal'
import AuthForms from '@/components/Account/AuthForms'
import { EventBus, Events } from '@/lib/events'

export default {
  components: { AuthForms, SplitModal },

  props: {
    registerTitle: { ƒtype: String, default: 'Launch your Brand' },
    loginTitle: { type: String, default: 'Launch your Brand' },
    scope: { type: String, default: 'Login/Register' },
    options: { type: Object, default: () => ({}) },
  },

  data: () => ({
    callback: null,
    modalOpen: false,
    settings: {
      canClose: false,
      modalOpen: false,
      modalType: 'register',
    },
  }),

  mounted() {
    EventBus.$on(Events.UserOpenAuthModal, this.handleModalOpenEvent)

    this.settings = { ...this.settings, ...this.options }

    // I know this is a bit weird but stick with me here
    // this.settings.modalOpen just tells us we want the modal to "try" to open
    // whereas this.modalOpen actually controls the state of the modal
    // brain empty, no thoughts
    if (this.settings.modalOpen) {
      this.shouldShowModal()
    }
  },

  beforeDestroy() {
    EventBus.$off(Events.UserOpenAuthModal, this.handleModalOpenEvent)
  },

  methods: {
    async shouldShowModal() {
      const auth = await this.$getAuthInstance()
      await auth
        .currentAuthenticatedUser()
        .then(() => {
          this.$emit('loggedIn')
          this.modalOpen = false
        })
        .catch(() => {
          this.$emit('loggedOut')
          this.modalOpen = true
        })
    },

    handleFormSubmit() {
      this.modalOpen = false

      if (this.callback && this.callback.resolve) {
        this.callback.resolve?.()
      }
    },

    handleCancel() {
      this.modalOpen = false

      if (this.callback && this.callback.reject) {
        this.callback.reject?.()
      }
    },

    handleModalOpenEvent({ modalType, canClose, resolve, reject, scope }) {
      if (scope === this.scope) {
        this.modalOpen = true
        this.settings.canClose = canClose
        this.settings.modalType = modalType
        this.callback = { resolve, reject }
      }
    },
  },
}
</script>
